import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Step 1: Import useNavigate
import { Icon } from "@iconify/react";
import { getDashboardData } from "../../services/dashboardService";

const UnitCountOne = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Step 2: Initialize navigate

  useEffect(() => {
    const loadDashboard = async () => {
      try {
        const res = await getDashboardData();
        if (res.status === "success") {
          setData(res.data);
        }
      } catch (error) {
        console.error("Failed to fetch dashboard data", error);
      } finally {
        setLoading(false);
      }
    };
    loadDashboard();
  }, []);

  if (loading) return <div className="p-4 text-muted">Loading Dashboard...</div>;
  if (!data) return null;

  // Step 3: Add the paths matching your <Route /> definitions
  const stats = [
    { 
      label: "Total Classes", 
      value: data.total_classes, 
      icon: "mdi:google-classroom", 
      color: "#4e73df",
      path: "/classes-management" 
    },
    { 
      label: "Students Photos", 
      value: data.total_photos, 
      icon: "mdi:image-multiple", 
      color: "#1cc88a",
      path: "/files-management" // Matches MangerPage
    },
    { 
      label: "Total Teachers", 
      value: data.total_teachers, 
      icon: "mdi:account-tie", 
      color: "#36b9cc",
      path: "/teacher-management" 
    },
    { 
      label: "Total Students", 
      value: data.school_students, 
      icon: "mdi:school", 
      color: "#f6c23e",
      path: "/files-management" // Add route if needed
    },
    
  ];

  return (
    <div className="unit-count-scope">
      <style>{`
        .unit-count-scope .stat-card {
          transition: transform 0.2s, box-shadow 0.2s;
          border-radius: 12px;
          border: 1px solid #e3e6f0;
          background: #fff;
          cursor: pointer; /* Change cursor to indicate clickability */
        }
        .unit-count-scope .stat-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
          border-color: #4e73df; /* Subtle highlight on hover */
        }
        .unit-count-scope .icon-wrapper {
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }
        .unit-count-scope .stat-label {
          color: #858796;
          font-size: 0.8rem;
          text-transform: uppercase;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .unit-count-scope .stat-value {
          font-size: 1.25rem;
          font-weight: 800;
          color: #5a5c69;
        }
      `}</style>

      <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-sm-2 row-cols-1 gy-4">
        {stats.map((item, index) => (
          <div className="col" key={index}>
            <div 
              className="card stat-card shadow-sm h-100"
              onClick={() => item.path && navigate(item.path)} // Step 4: Handle Click
            >
              <div className="card-body p-20">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="stat-label">{item.label}</p>
                    <h6 className="stat-value mb-0">{item.value}</h6>
                  </div>
                  <div className="icon-wrapper" style={{ backgroundColor: `${item.color}20` }}>
                    <Icon icon={item.icon} style={{ color: item.color }} className="text-2xl" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnitCountOne;